export const VOD_ASSET_TYPE = "VOD";
export const TV_ASSET_TYPE = "TV";
